import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import DefaultCompanyValueInput from '../DefaultCompanyValueInput';
import InfoPopover from '../../atoms/InfoPopover';
import { settingShape } from '../../../../../services/repository/settingRepository/objects/setting';

function DefaultCompanyValues({ settings, onChange }) {
  const popoverContent =
    'Atribuir valores nos Itens "Para a Empresa", irá definir esses valores como padrão para cálculos da tabela da empresa';
  const FormLabel = (
    <span>
      <b>Para a Empresa</b>
      <InfoPopover placement="right" content={popoverContent} />
    </span>
  );

  return (
    <>
      {FormLabel}
      <Row gutter={24} style={{ marginTop: '16px' }}>
        {Object.entries(settings).map(([key, { label, value, valueType }]) => (
          <Col xs={24} sm={12} md={8} lg={6} xl={6} key={key}>
            <DefaultCompanyValueInput
              id={key}
              label={label}
              value={value}
              valueType={valueType}
              onChange={onChange}
            />
          </Col>
        ))}
      </Row>
    </>
  );
}

DefaultCompanyValues.propTypes = {
  settings: PropTypes.shape(settingShape).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DefaultCompanyValues;
